/* global squiz */

import Glide, {
    Controls,
    Breakpoints,
    Swipe,
} from "@glidejs/glide/dist/glide.modular.esm";

let carouselConfigs = {};

const carousel = () => {
    const carousels = document.querySelectorAll(
        ".glide[data-glide-story-carousel-id]"
    );
    const carouselsNone = document.querySelectorAll(".glide-none");
    if (carousels) {
        Array.from(carousels).forEach((storyCarousel) => {
            const id = storyCarousel.dataset.glideSliderId;
            if (storyCarousel.querySelectorAll(".glide__slide").length > 3) {
                carouselConfigs[id] = new Glide(storyCarousel, {
                    type: "carousel",
                    startAt: 0,
                    perView: 3,
                    gap: 30,
                    breakpoints: {
                        1199: {
                            perView: 2,
                        },
                        767: {
                            perView: 1,
                        },
                    },
                });

                // turn off loading screan
                carouselConfigs[id].on("mount.after", function () {
                    storyCarousel
                        .querySelector(".glide__track")
                        .classList.remove("loading");
                    // storyCarousel.querySelector('.lottie-loader').remove();
                });
                // render carousel or not - depending on resolution
                if (window.innerWidth >= squiz.vars.desktopWidth) {
                    carouselConfigs[id].mount({ Controls, Breakpoints, Swipe });
                } else {
                    storyCarousel
                        .querySelector(".glide__track")
                        .classList.remove("loading");
                    // storyCarousel.querySelector('.lottie-loader').remove()
                }
            }
        });
    }
    if (carouselsNone) {
        Array.from(carouselsNone).forEach((storyCarousel) => {
            storyCarousel
                .querySelector(".glide__track")
                .classList.remove("loading");
            // storyCarousel.querySelector('.lottie-loader').remove()
        });
    }
};

export default carousel;
